import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";
import moment from "moment";
import { Link } from "react-router-dom";
import { Prompt } from "react-router";

import { connect } from "react-redux";

import { Can } from "constants/abilityContext";
import { NOTE_TYPE_SSE } from "constants/dbValues";
import { icons } from "constants/icons";
import {
  history,
  title,
  isChecked,
  validateProfileFields,
  dateFormat,
  datePickerProps,
  selectProps,
  displayErrorContext,
  List,
} from "utils";

import { Header, DocumentsList, ProjectLog } from "components";
import {
  Icon,
  Divider,
  Input,
  DatePicker,
  notification,
  Button,
  Checkbox,
  Select,
  Spin,
  Row,
  Col,
} from "antd";

import { projectService, clientService, userService, selectService } from "services";

// Composant de détails d'un modèle.
// Beaucoup d'optimisation possible (React Modeling 04h11 pour code optimisé et centralisé).
//
// Les fonctions suivantes sont implémentées :
// - fetchSelects()
//   Fetch les options des dropdowns avec le selectService.
// - formatTag()
//   Render le html approprié selon les clés données dans le html.
//   En read render du static, en edit ou create render des inputs.
// - handleChange()
//   Gère le changement d'une valeur.
// - handleSubmit()
//   Gère le submit du form, tant en edit qu'en create.
// - validateFields()
//   Valide les champs du form qui sont required, utilise la fonction validateProfileFields
//   de utils/form.
// - render()
//   Render commun pour les 3 modes, la gestion des inputs se fait dans
//   formatTag(), mais les conditions plus générales se font directement dans render()
class ProjectPage extends Component {
  constructor(props) {
    super(props);

    const { id } = this.props.match.params;

    this.state = {
      project: {
        __type: "Project",
        id: id,
        documents: [],
      },
      uploading: false,
      errors: {},
      edited: false,
      types: [],
      clients: [],
      users: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateFields = this.validateFields.bind(this);
  }

  componentDidMount() {
    const { project } = this.state;
    const { edit, create } = this.props;

    this.doclist = React.createRef();

    if (!create) {
      projectService
        .get(project.id)
        .then((result) => {
          if (edit) result.users = result.users.map((u) => u.id);
          this.setState({ project: { ...project, ...result } });
        })
        .catch((e) => {
          history.push("/projects");
        });
    }

    if (edit || create) this.fetchSelects();
  }

  componentWillReceiveProps(nextProps) {
    const { types } = this.state;
    const { edit, create } = nextProps;
    if ((!types || types.length === 0) && (edit || create)) this.fetchSelects();
  }

  async fetchSelects() {
    const selects = await selectService.listForPage("project");
    const clients = await clientService.list();
    const users = await userService.list();

    this.setState({ types: selects.ProjectType, clients, users });
  }

  formatTag(key, fixed = false, label = "") {
    const { project, errors } = this.state;
    const { edit, create } = this.props;

    if ((!edit && !create) || (fixed && edit)) {
      switch (key) {
        case "type_id":
          return project.project_type ? (
            <>
              <Icon type="tag" />
              {project.project_type.label}
            </>
          ) : (
            ""
          );
        case "client_id":
          return project.client ? (
            <Link to={`/clients/${project.client_id}`}>
              <Icon type={icons.client} />
              {`${project.client.name}`}
            </Link>
          ) : (
            ""
          );
        case "disabled":
          return !isChecked(project[key]) ? (
            <>
              <Icon type="check-circle" />
              Ouvert
            </>
          ) : (
            <>
              <Icon type="close-circle" />
              Fermé
            </>
          );
        case "users":
          return (
            <b>
              {(project[key] || []).map((u) => (
                <i key={u.id} className="list-item">
                  {u.name}
                </i>
              ))}
            </b>
          );
        case "date_begin":
        case "date_end":
          return <b>{moment(project[key]).format(dateFormat)}</b>;
        default:
          return <b>{project[key]}</b>;
      }
    }

    var input;
    if (key === "disabled") {
      input = (
        <Checkbox
          name={key}
          checked={isChecked(project[key])}
          onChange={(e) => this.handleChange(e.target.checked, key)}
        >
          {label}
        </Checkbox>
      );
    } else if (key === "date_begin" || key === "date_end") {
      input = (
        <DatePicker
          name={key}
          value={project[key] ? moment(project[key]) : null}
          onChange={(date, value) => this.handleChange(date, key)}
          {...datePickerProps()}
        />
      );
    } else if (key === "type_id" || key === "client_id" || key === "users") {
      var list = [],
        computeLabel = (t) => t.label;
      if (key === "type_id") {
        list = this.state.types;
      }
      if (key === "client_id") {
        list = this.state.clients;
        computeLabel = (t) => t.name;
      }
      if (key === "users") {
        list = this.state.users;
        computeLabel = (t) => t.name + " " + t.surname;
      }

      var options = list.map((t) => (
        <Select.Option key={t.id} value={t.id}>
          {computeLabel(t)}
        </Select.Option>
      ));

      input = (
        <Select
          mode={key === "users" ? "multiple" : "default"}
          value={project[key]}
          onChange={(value) => this.handleChange(value, key)}
          {...selectProps()}
        >
          {options}
        </Select>
      );
    } else {
      var Tag = key === "description" ? Input.TextArea : Input;

      input = (
        <Tag
          name={key}
          value={project[key]}
          autoSize={{ minRows: 3, maxRows: 20 }}
          onChange={(e) => this.handleChange(e.target.value, key)}
        />
      );
    }

    var error = errors && errors[key];
    return <span className={error ? "error-wrap" : ""}>{input}</span>;
  }

  handleChange(value, key) {
    this.setState({
      project: { ...this.state.project, [key]: value },
      edited: true,
    });
  }

  handleSubmit() {
    if (!this.validateFields()) return;

    var project = { ...this.state.project };
    const { edit, create } = this.props;

    var func;

    if (edit) {
      func = projectService.update;
    } else if (create) {
      func = projectService.create;
    }

    project.disabled = project.disabled ? 1 : 0;

    delete project.project_type;
    delete project.documents;
    delete project.notes;
    delete project.tailgates;
    delete project.incidents;

    const errorNotif = (e) => {
      this.setState({ uploading: false });
      notification.open({
        message: "Une erreur s'est produite",
        description: "Veuillez réessayer ou contacter un administrateur.",
        placement: "bottomRight",
      });
    };

    this.setState({ uploading: true }, () => {
      func(project)
        .then((n) => {
          this.doclist.current
            .executeActions(n.id, "Project")
            .then(() => {
              notification.open({
                message: "Enregistrement effectué",
                description: "Vos changements ont été enregistrés avec succès.",
                placement: "bottomRight",
              });

              this.setState({
                project: { ...project, ...n },
                edited: false,
                uploading: false,
              });
              history.replace(`/projects/${n.id}`);
            })
            .catch((e) => errorNotif(e));
        })
        .catch((e) => errorNotif(e));
    });
  }

  validateFields() {
    const { project } = this.state;
    const { edit, create } = this.props;

    var fields = ["code", "client_id", "type_id", "label", "date_begin", "date_end"];
    var validation = validateProfileFields(project, fields);

    this.setState({ errors: validation.errors });
    return !validation.hasError;
  }

  render() {
    const { project, errors, uploading } = this.state;
    const { edit, create } = this.props;

    var mode = "read",
      pageTitle = "Détails d'un projet",
      header = `Projet ${project.code ? project.code : ""}`,
      bread = [{ to: "/projects", text: "Liste des projets" }, { text: project.code }];

    if (edit) {
      mode = "edit";
      pageTitle = "Édition d'un projet";
      bread = [
        { to: "/projects", text: "Liste des projets" },
        { to: `/projects/${project.id}`, text: project.code },
        { text: "Édition" },
      ];
    } else if (create) {
      mode = "create";
      pageTitle = "Création d'un projet";
      header = "Nouveau projet";
      bread = [{ to: "/projects", text: "Liste des projets" }, { text: "Création" }];
    }

    const renderBottomFields = () => (
      <>
        {edit || create ? <Divider /> : <></>}

        <div className="blocks">
          <div>
            <h3>Intervenant SSE</h3>
            <div className="ctn">
              <label>Prénom :</label>
              {this.formatTag("sse_name")}
            </div>

            <div className="ctn">
              <label>Nom :</label>
              {this.formatTag("sse_surname")}
            </div>

            <div className="ctn">
              <label>Téléphone :</label>
              {this.formatTag("sse_tel")}
            </div>

            <div className="ctn">
              <label>Courriel :</label>
              {this.formatTag("sse_mail")}
            </div>
          </div>

          <div>
            <h3>Chargé de projet du client</h3>
            <div className="ctn">
              <label>Prénom :</label>
              {this.formatTag("ssc_name")}
            </div>

            <div className="ctn">
              <label>Nom :</label>
              {this.formatTag("ssc_surname")}
            </div>

            <div className="ctn">
              <label>Téléphone :</label>
              {this.formatTag("ssc_tel")}
            </div>

            <div className="ctn">
              <label>Courriel :</label>
              {this.formatTag("ssc_mail")}
            </div>
          </div>
        </div>
      </>
    );

    return (
      <Fragment>
        <Helmet>{title(pageTitle)}</Helmet>

        <Header title={header} bread={bread} />

        <div className={`project-page main-content profile-content ${mode}`}>
          <Can do={mode} on={project}>
            <Spin
              indicator={<Icon type="loading" spin style={{ fontSize: "52px" }} />}
              spinning={uploading}
            >
              {mode === "read" && (
                <ul className="tags">
                  <li>{this.formatTag("client_id")}</li>
                  <li className="alt">{this.formatTag("type_id")}</li>
                  <li className="alt">{this.formatTag("disabled")}</li>
                </ul>
              )}

              <div className={"profile-main-content " + mode}>
                <div className="main-block">
                  {mode !== "read" && (
                    <Fragment>
                      <div className="ctn">
                        {this.formatTag("disabled", false, "Ce projet est fermé")}
                      </div>
                      <div className="ctn">
                        <label>Code :</label>
                        {this.formatTag("code")}
                      </div>
                    </Fragment>
                  )}

                  <Row gutter={[24, 16]}>
                    <Col md={mode === "read" ? 12 : 24} xs={24}>
                      <div className="ctn">
                        <label>Nom du projet :</label>
                        {this.formatTag("label")}
                      </div>
                      <div className="ctn">
                        <label>Description :</label>
                        {this.formatTag("description")}
                      </div>

                      <div className="ctn">
                        <label>Date de début :</label>
                        {this.formatTag("date_begin")}
                      </div>

                      <div className="ctn">
                        <label>Date de fin :</label>
                        {this.formatTag("date_end")}
                      </div>
                    </Col>
                    <Col md={mode === "read" ? 0 : 24} xs={24}>
                      <Divider />
                    </Col>
                    <Col md={mode === "read" ? 12 : 24} xs={24}>
                      <div className="ctn">
                        <label>Utilisateurs liés au projet :</label>
                        {this.formatTag("users")}
                      </div>
                    </Col>
                  </Row>

                  {mode !== "read" && (
                    <Fragment>
                      <div className="ctn">
                        <label>Client :</label>
                        {this.formatTag("client_id")}
                      </div>

                      <div className="ctn">
                        <label>Type :</label>
                        {this.formatTag("type_id")}
                      </div>
                    </Fragment>
                  )}

                  <Divider />
                  <Row gutter={[24, 16]}>
                    <Col md={mode === "read" ? 12 : 24} xs={24}>
                      <div className="ctn">
                        <label>Addresse :</label>
                        {this.formatTag("address")}
                      </div>

                      <div className="ctn">
                        <label>Code postal :</label>
                        {this.formatTag("zipcode")}
                      </div>
                    </Col>
                    <Col md={mode === "read" ? 12 : 24} xs={24}>
                      <div className={mode === "read" ? "no-divider" : ""}>
                        <DocumentsList
                          ref={this.doclist}
                          documents={project.documents}
                          editable={edit || create}
                          handleChange={this.handleChange}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>

                <Can do="read_admin" on="General">
                  <div className="infos-block">
                    <Divider />

                    {/*
                                            <div className="ctn">
                                                <label># CLB :</label>
                                                { this.formatTag('estimated_nb_clb') }
                                            </div>

                                            <div className="ctn">
                                                <label># sous-contractés :</label>
                                                { this.formatTag('estimated_nb_subcontractor') }
                                            </div>
                                        */}

                    <div className="ctn">
                      <label>Heures CLB :</label>
                      {this.formatTag("estimated_hours_clb")}
                    </div>

                    <div className="ctn">
                      <label>Heures sous-contractants :</label>
                      {this.formatTag("estimated_hours_subcontractor")}
                    </div>
                  </div>
                </Can>

                {mode !== "read" ? renderBottomFields() : <></>}
              </div>

              {(edit || create) && (
                <Fragment>
                  {displayErrorContext(errors)}

                  <div className="buttons">
                    <Button type="link" onClick={() => history.goBack()}>
                      Annuler
                    </Button>
                    <Button
                      type="primary"
                      disabled={edit && !this.state.edited}
                      onClick={() => this.handleSubmit()}
                    >
                      {edit ? "Enregistrer les changements" : "Créer le projet"}
                    </Button>
                  </div>

                  <Prompt
                    when={this.state.edited}
                    message="Attention, certaines de vos modifications n'ont pas été enregistrées. Voulez-vous vraiment quitter cette page ?"
                  />
                </Fragment>
              )}

              {!edit && !create && (
                <div className="buttons">
                  <Button type="link" href={`#/documents/projects/${project.id}`}>
                    Accéder à la galerie
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => history.push("/projects/" + project.id + "/edit")}
                  >
                    Éditer ce project
                  </Button>
                </div>
              )}
            </Spin>
          </Can>
        </div>

        {mode === "read" && (
          <Fragment>
            <div className="secondary-content">
              <div className="log-wrap">
                <h2>Journal de chantier</h2>
                <ProjectLog fixedProject={project} />
              </div>
            </div>

            <div className="secondary-content">
              <List type="tailgates" title="Tailgates" filters={{ project_id: project.id }} />
            </div>

            <div className="secondary-content">
              <List type="incidents" title="Incidents" filters={{ project_id: project.id }} />
            </div>

            <div className="secondary-content">
              <List
                type="sse"
                title="Inter. SSE"
                filters={{ project_id: project.id, type_id: NOTE_TYPE_SSE }}
              />
            </div>

            <div className="secondary-content">
              <List type="compliances" title="Non-conf." filters={{ project_id: project.id }} />
            </div>

            <div className="main-content profile-content project-page bottom-block">
              {renderBottomFields()}
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default ProjectPage;
